import { fromUnixTime, isBefore, format } from 'date-fns'
import countdownLib from 'countdown'
import { TRACKCONDITION, RACESTATUS, ROLEACTIONCODE } from './constants'
import base32Encode from 'base32-encode'

export const countdown = function (unixSeconds) {
  const time = fromUnixTime(unixSeconds)
  var ts = countdownLib(time)
  var formatted = ''
  if (ts.months > 1) {
    formatted = ts.months + ' months'
  } else if (ts.days === 0) {
    if (ts.hours === 0 && ts.minutes >= 5) {
      formatted = ts.minutes + 'm '
    } else if (ts.hours === 0 && ts.minutes <= 5) {
      formatted = ts.minutes + 'm ' + ts.seconds + 's'
    } else {
      formatted = ts.hours + 'h ' + ts.minutes + 'm'
    }
  } else {
    formatted = ts.days + 'd'
  }

  if (isBefore(time, new Date())) {
    formatted = '-' + formatted
  }

  return formatted
}

export const countdownObject = function (unixSeconds) {
  const time = fromUnixTime(unixSeconds)
  return countdownLib(time)
}

export const formattedRaceStartTime = (seconds) => {
  const formatted = format(seconds, 'HH:mm')
  return formatted
}

export const filterRacesByCountry = (races, filters) => {
  if (races && filters) {
    return Object.keys(races)
      .filter(race => filters.includes(races[race].meeting.track.country) || !races[race].meeting.track.country)
      .map(key => races[key])
  } else {
    return races
  }
}

export const filterMeetingsByCountry = (meetings, filters) => {
  if (meetings && filters) {
    const a = meetings
      .filter(meeting => filters.includes(meeting.track.country) || !meeting.track.country)
    return a
  } else {
    return meetings
  }
}

export const filterRacesByCodes = function (races, filters) {
  if (races && filters) {
    return Object.keys(races)
      .filter(race => filters.includes(races[race].meeting.type) || !races[race].meeting.type)
      .map(key => races[key])
  } else {
    return races
  }
}

export const filterMeetingsByCodes = function (meetings, filters) {
  if (meetings && filters) {
    return meetings
      .filter(meeting => filters.includes(meeting.type) || !meeting.type)
  } else {
    return meetings
  }
}

export const filterRacesByMeetingType = (races, filters) => {
  if (races && filters) {
    return Object.keys(races)
      .filter(race => {
        return filters.includes(races[race].meeting.tabIndicator) || (filters.includes('P') && !races[race].meeting.tabIndicator)
      })
      .map(key => races[key])
  } else {
    return races
  }
}

/* export const filterRacesByStatuses = (races, filters) => {
  const OPEN_STATUS = ['OPEN']
  const CLOSED_STATUS = ['CLOSED']
  const INT_PAY_STATUS = ['INTERIM']
  if (races && filters) {
    return Object.keys(races)
      .filter(race => {
        if (filters.includes('Open')) {
          if (OPEN_STATUS.includes(races[race].status)) return true
        }
        if (filters.includes('Closed')) {
          if (CLOSED_STATUS.includes(races[race].status)) return true
        }
        if (filters.includes('Interim/Paying')) {
          if (INT_PAY_STATUS.includes(races[race].status)) return true
        }
        return false
      })
      .map(key => races[key])
  } else {
    return races
  }
} */

export const filterRacesByStatuses = (races, filters) => {
  if (races && filters) {
    return Object.keys(races)
      .filter(race => {
        const value = RACESTATUS[races[race].status]
        if (!value) {
          return true
        }
        return value ? (filters.some(filter => value.includes(filter)) || !value) : true
      })
      .map(key => races[key])
  } else {
    return races
  }
}

export const filterRacesByStarters = (races, filters) => {
  if (races && filters) {
    return Object.keys(races)
      .filter(race => {
        return races[race].starters >= filters[0] && races[race].starters <= filters[1]
      })
      .map(key => races[key])
  } else {
    return races
  }
}

export const filterRacesByDistance = (races, filters) => {
  if (races && filters) {
    return Object.keys(races)
      .filter(race => {
        return races[race].distance >= filters[0] && races[race].distance <= filters[1]
      })
      .map(key => races[key])
  } else {
    return races
  }
}

export const filterRacesByCondition = (races, filters) => {
  if (races && filters) {
    return Object.keys(races)
      .filter(race => {
        const value = TRACKCONDITION[races[race].trackCondition]
        if (value && !filters.some(filter => value.includes(filter))) {
          //
        } else if (!value) {
          return true
        }
        return value ? (filters.some(filter => value.includes(filter)) || !value) : true
      })
      .map(key => races[key])
  } else {
    return races
  }
}

export const userHasResourceAccess = (userPermissions, resourceUri, action) => {
  let directAccess =  userPermissions.find(up=> up.uri === resourceUri && up.actions.includes(action))
  // if only check read access to parent resource, match with uri is fine
  let indirectAccess = action == ROLEACTIONCODE.READ? userPermissions.find( p => p.uri.startsWith(resourceUri)) : false

  return directAccess || indirectAccess
}


export const generatePublicID = async (privateId) =>{

  const salt = 'h4r5h4155tr0nge5tbl4hbl4h'
  const encoder = new TextEncoder()
  const inputStr = encoder.encode(privateId + salt) 
  const sha256hash = await crypto.subtle.digest('SHA-256',inputStr)

  const encodedPublicIdFull  = base32Encode(sha256hash, 'RFC4648')

  return sliceIntoChunks(encodedPublicIdFull.substring(0,16).split(''),4).map(g=>g.join('')).join('-')
}

export const sliceIntoChunks = (arr, chunkSize) => {
  const res = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
      const chunk = arr.slice(i, i + chunkSize);
      res.push(chunk);
  }
  return res;
}

